import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight, Clock } from "lucide-react";
import { posts } from "../data/site";
import { Reveal } from "../components/Reveal";

export default function Blog() {
  const [hero, ...rest] = posts;
  return (
    <div data-testid="blog-page" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">Blog</span>
        </div>

        <div className="mb-16 max-w-3xl">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
            Günlük
          </div>
          <h1 className="font-serif-display text-3xl md:text-4xl text-[#1E1E1E] leading-tight">
            Yüzeyin sanatı
          </h1>
        </div>

        {/* Hero post */}
        {hero && (
          <Reveal>
            <Link
              to={`/blog/${hero.slug}`}
              data-testid={`blog-hero-${hero.slug}`}
              className="group grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-24"
            >
              <div className="clip-frame aspect-[4/3] overflow-hidden">
                <img
                  src={hero.cover}
                  alt={hero.title}
                  className="w-full h-full object-cover img-zoom"
                />
              </div>
              <div>
                <div className="flex items-center gap-3 text-[10px] tracking-[0.25em] uppercase text-[#888]">
                  <span className="text-[#B8860B]">{hero.category}</span>
                  <span>·</span>
                  <span>{hero.date}</span>
                  <span>·</span>
                  <span className="flex items-center gap-1"><Clock size={11} /> {hero.readTime}</span>
                </div>
                <h2 className="mt-4 font-serif-display text-2xl md:text-3xl text-[#1E1E1E] leading-tight group-hover:text-[#B8860B] transition-colors">
                  {hero.title}
                </h2>
                <p className="mt-3 text-[14px] text-[#555] leading-relaxed line-clamp-2">
                  {hero.excerpt}
                </p>
                <div className="mt-6 flex items-center gap-3">
                  <img
                    src={hero.author.avatar}
                    alt={hero.author.name}
                    className="w-9 h-9 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-[13px] text-[#1E1E1E]">{hero.author.name}</div>
                    <div className="text-[11px] text-[#888]">{hero.author.role}</div>
                  </div>
                </div>
                <div className="mt-8 inline-flex items-center gap-2 text-[#1E1E1E] group-hover:text-[#B8860B] transition-colors">
                  Yazıyı Oku <ArrowRight size={14} />
                </div>
              </div>
            </Link>
          </Reveal>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {rest.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block"
              >
                <div className="clip-frame aspect-[4/3] overflow-hidden">
                  <img
                    src={p.cover}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover img-zoom"
                  />
                </div>
                <div className="mt-5 flex items-center gap-3 text-[10px] tracking-[0.25em] uppercase text-[#888]">
                  <span className="text-[#B8860B]">{p.category}</span>
                  <span>·</span>
                  <span>{p.readTime}</span>
                </div>
                <h3 className="mt-2 font-serif-display text-xl text-[#1E1E1E] leading-snug group-hover:text-[#B8860B] transition-colors">
                  {p.title}
                </h3>
                <p className="mt-2 text-[13px] text-[#666] leading-relaxed line-clamp-2">
                  {p.excerpt}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
